import PropTypes from 'prop-types';
import ReactFocusLock from 'react-focus-lock';

function FocusTrap({ children, isDisabled }) {
  return (
    <ReactFocusLock
      disabled={isDisabled}
    >
      <div role="dialog" aria-modal>
        {children}
      </div>
    </ReactFocusLock>
  );
}

FocusTrap.propTypes = {
  children: PropTypes.node,
  isDisabled: PropTypes.bool,
};

FocusTrap.defaultProps = {
  children: '',
  isDisabled: true,
};

export default FocusTrap;
